export const AppRoutes = {
  Home: "/",
  ProgramId: "/:id",
} as const;
